import DividerWithText from '../../../../../components/DividerWithText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import { useTranslation } from 'react-i18next';
import RowResumeText from '../../../../../components/RowResumeText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import WorkShiftsItem from '../../../Company/Employees/AccessRightsSection/Components/WorkShiftsItem';
import CustomizedItem from '../../../Company/Employees/AccessRightsSection/Components/CustomizedItem';
import NotInformation from '../../../../../components/NotInformation';
import SummaryContainer from '../../Components/SummaryContainer';
import SummaryFieldsUser from '../../Components/SummaryFieldsUser';

const Summary = ({
    user,
    workShiftsList,
    customizedList,
    photoPicker,
    getAllServiceType,
    extraDataEnabled,
    headersList,
    extraData,
}) => {
    const { t } = useTranslation();

    const item = getAllServiceType.find((item) => item.id === user?.serviceTypeId);
    return (
        <>
            <DividerWithText title={t('take_photography')} />
            <PhotoPickerSummary photoPicker={photoPicker} classWith={'content-center-w-400px'} />

            <DividerWithText title={t('company_details')} />
            <SummaryContainer>
                <div className='row'>
                    <div className='col-12 col-sm-6 pb-2'>
                        <RowResumeText title={t('acronym')} value={user?.acronym || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className='col-12 col-sm-6 pb-2'>
                        <RowResumeText
                            title={t('company_name')}
                            value={user?.contractorCompanyName || EMPTY_VALUES.DEFAULT}
                        />
                    </div>
                    <div className='col-12 col-sm-6 pb-2'>
                        <RowResumeText title={t('address')} value={user?.address || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className='col-12 col-sm-6 pb-2'>
                        <RowResumeText title={t('service_type')} value={item?.name || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className='col-12 pb-2'>
                        <RowResumeText title={t('description')} value={user?.description || EMPTY_VALUES.DEFAULT} />
                    </div>
                </div>
            </SummaryContainer>

            <DividerWithText title={t('manager_details')} />
            <SummaryContainer>
                <div className='row'>
                    <SummaryFieldsUser user={user} />
                </div>
            </SummaryContainer>
            {extraDataEnabled && (
                <>
                    <DividerWithText title={t('other_details')} />
                    <SummaryContainer>
                        <div className='row'>
                            <div className='grid-container-resume-data mb-2'>
                                {Array.from({ length: 15 }, (_, index) => (
                                    <RowResumeText
                                        key={index}
                                        title={headersList[`header${index + 1}`] || `header_${index + 1}`}
                                        value={extraData[`field${index + 1}`]}
                                    />
                                ))}
                            </div>
                        </div>
                    </SummaryContainer>
                </>
            )}
            <DividerWithText title={t('access_right')} />
            <>
                {workShiftsList?.length === 0 ? (
                    <>
                        <p className='fs-14px ibl-font-w-600 font-color-general-950 py-3'>{t('work_shift')}</p>
                        <div className='col-12'>
                            <NotInformation text={t('no_work_shifts_added_yet')} card={true} className={'h-215px'} />
                        </div>
                    </>
                ) : (
                    <SummaryContainer>
                        <WorkShiftsItem t={t} list={workShiftsList} showNoInformation={false} iconDelete={false} />
                    </SummaryContainer>
                )}

                {customizedList.length === 0 ? (
                    <>
                        <p className='fs-14px ibl-font-w-600 font-color-general-950 py-3'>{t('custom_access')}</p>
                        <div className='col-12'>
                            <NotInformation text={t('no_custom_shifts_added_yet')} card={true} className={'h-215px'} />
                        </div>
                    </>
                ) : (
                    <SummaryContainer>
                        <CustomizedItem t={t} list={customizedList} showNoInformation={false} iconDelete={false} />
                    </SummaryContainer>
                )}
            </>
        </>
    );
};

export default Summary;
